import { iAdministrator } from '~/domain/interfaces/models/';
import { AdministratorTypes } from '~/domain/interfaces/redux/administrator/types';
import { AuthTypes } from '~/domain/interfaces/redux/auth/types';
import { AdministratorActions } from './actions';

export const initialState: iAdministrator = {
  loading: false,
  pageSize: 0,
  totalItems: 0,
  results: [],
};

const reducer = (
  state = initialState,
  action: AdministratorActions,
): iAdministrator => {
  switch (action.type) {
    case AdministratorTypes.CREATE:
      return state;
    case AdministratorTypes.GETALL:
      return { ...state, loading: true };
    case AdministratorTypes.GETALL_SUCCESS:
      return {
        ...state,
        pageSize: action.payload.pageSize,
        totalItems: action.payload.totalItems,
        results: action.payload.results,
        loading: false,
      };
    case AdministratorTypes.GETALL_FAILED:
      return { ...state, loading: false };
    case AuthTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
